export function toggleValue(selected: string[], value: string, multiple: boolean | undefined): string[] {
  const isSelected = selected.includes(value);

  if (!multiple) {
    return isSelected ? [] : [value];
  }

  return isSelected
    ? selected.filter((v) => {
        return v !== value;
      })
    : [...selected, value];
}
